import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Service } from '../Service.js';
import { AppSettings } from '@app/helpers/app.settings';
import { AppHelper } from '@app/helpers/app.helper';

@Injectable()
export class ProfileService extends Service {
  constructor(private _http: HttpClient) {
    super();
  }

  getProfilePopular(filter) {
    return this._http
      .get(
        this.API_ENDPOINT +
          'profile/popular?' +
          AppHelper.serializeObj(filter),
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.error(error, error._body);
      });
  }

  getProfile(filter) {
    return this._http
      .get(
        this.API_ENDPOINT + 'profile?' + AppHelper.serializeObj(filter),
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.error(error, error._body);
      });
  }

  updateProfileImage(data) {
    return this._http
      .put(
        this.API_ENDPOINT + 'profile/image',
        data,
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.error(error, error._body);
      });
  }

  getProfileSettings(filter) {
    return this._http
      .get(
        this.API_ENDPOINT +
          'profile/settings?' +
          AppHelper.serializeObj(filter),
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.error(error, error._body);
      });
  }

  updateProfile(data) {
    return this._http
      .put(
        this.API_ENDPOINT + 'profile',
        data,
        this.APP_REQUEST_OPTIONS
      )
      .toPromise()
      .catch((error) => {
        console.error(error, error._body);
      });
  }
}
